/** @format */

import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SkeletonCompareGridProductCardComponent } from '../skeleton-compare-grid-product-card/skeleton-compare-grid-product-card.component';

@Component({
	selector: 'plp-components-compare-grid-product-card',
	imports: [SkeletonCompareGridProductCardComponent],
	templateUrl: './compare-grid-product-card.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompareGridProductCardComponent {
	isCompact = input.required<boolean>();
	isLoading = input.required<boolean>();
}
